import React from 'react';

import { Row } from '~components/table-view-v3';

import PaymentSourceBadge from '~direct-debits/components/PaymentSourceBadge';

import StatusBadge from '~support-at-home/forms/supplier-invoices/StatusBadge';

// TAV-2053: composite status cell — pairs the existing lookup-driven status
// badge with a source indicator (lock for GoCardless-managed, pencil for
// manually-set). Status and source are conceptually one piece of information
// for the user, so they share the column.
const StatusWithSourceCell: React.FC<{ row: Row }> = ({ row }) => (
  <div className="d-flex align-items-center gap-2">
    <StatusBadge row={row} />
    <PaymentSourceBadge row={row} />
  </div>
);

export default StatusWithSourceCell;
